import { Identifiable, Resource, resource } from "@planzone/dto";

type Comment = {
  author: Identifiable<Resource>;
  recipients: Identifiable<Resource>[];
  content: string;
  createdDate: string;
  replyTo?: Identifiable<Comment>;
  attributes?: {
    type?: string;
    name?: string;
    path?: string;
    elementUuid?: string;
  };
  isLog: boolean;
};

const comment: Comment = {
  author: { ...resource, uuid: "" },
  recipients: [],
  content: "",
  createdDate: "",
  attributes: {
    type: "",
  },
  isLog: false,
};

export type { Comment };

export { comment };
